import axios from "axios"

import { useStore } from "../zustand/store"

const API_LINK = import.meta.env.VITE_API_URL

export default function useAxios() {
  const authData = useStore((state) => state.authData)

  return axios.create({
    baseURL: API_LINK,
    headers: {
      Authorization: `Bearer ${authData?.token}`,
      "Content-Type": "application/json",
      Accept: "application/json",
      "accept-language": "en",
    },
  })
}
